import React, { useRef, useState } from 'react';
import { ShieldAlert, Check, X } from 'lucide-react';
import { approvalTitle } from './chatHelpers';

const RESOLVED = { approved: 'Approved', denied: 'Denied', timeout: 'Timed out (denied)' };

// Summary and warning come from the tool input, so they are rendered strictly as text (React
// escapes them). Never render them as raw HTML.
export default function ApprovalCard({ item, onDecide }) {
  const pending = item.status === 'pending';
  const [deciding, setDeciding] = useState(false);
  const [failure, setFailure] = useState('');
  const inFlight = useRef(false);

  const decide = async (decision) => {
    if (inFlight.current) return; // one decision per card at a time
    inFlight.current = true;
    setDeciding(true); setFailure('');
    const res = await onDecide(item.approvalId, decision);
    inFlight.current = false;
    // On success keep both buttons disabled until approval_resolved arrives; on failure re-enable.
    if (res && res.ok === false) { setDeciding(false); setFailure(res.message || 'Could not record the decision'); }
  };

  return (
    <div className={`cc-approval${pending ? '' : ' cc-approval-done'}`}>
      <div className="cc-approval-title"><ShieldAlert size={16} /> {approvalTitle(item.toolName)}</div>
      {item.summary ? <pre className="cc-approval-summary">{item.summary}</pre> : null}
      {item.warning && <div className="cc-approval-warning">{item.warning}</div>}
      {pending ? (
        <>
          <div className="cc-approval-actions">
            <button type="button" className="cc-btn cc-btn-primary" disabled={deciding} onClick={() => decide('approve')}>
              {deciding ? 'Sending…' : 'Approve'}
            </button>
            <button type="button" className="cc-btn" disabled={deciding} onClick={() => decide('deny')}>
              {deciding ? 'Sending…' : 'Deny'}
            </button>
          </div>
          {failure && <div role="alert" className="cc-approval-warning">{failure}</div>}
        </>
      ) : (
        <div className={`cc-approval-resolved cc-${item.status === 'approved' ? 'ok' : 'no'}`}>
          {item.status === 'approved' ? <Check size={14} /> : <X size={14} />} {RESOLVED[item.status] || item.status}
        </div>
      )}
    </div>
  );
}
